export const scrollTopHelper = (selector: string, scrollObject?: ScrollIntoViewOptions): void => {
  if (!selector) return;
  const el = document?.querySelector(selector);
  if (typeof el !== 'undefined' && el !== null) {
    if (scrollObject) el.scrollIntoView(scrollObject);
    else el.scrollIntoView(true);
  }
};
